import { useEffect, useState } from 'react';
import { Category } from '../../../commonTypes/user.types';
import { useContainer } from '../../useContainer';
import { ToastStateHandler, UserApi } from '../../../api';
import { useTranslation } from '../../useTranslation';

const useHttpGetCategories = () => {
    const userApi = useContainer(UserApi);
    const toastHandler = useContainer(ToastStateHandler);
    const { t } = useTranslation('newNotifications');
    const [categories, setCategories] = useState<{ category: Category; documentCount: number }[]>([]);
    const [areCategoriesReady, setAreCategoriesReady] = useState(true);
    useEffect(() => {
        const { exec, abort } = userApi.getDocumentCategories({
            params: {},
            onSuccess: res => setCategories(res.body),
            onError: () => toastHandler.push(`error`, t('common.error'), t('common.somethingWentWrong')),
            onFinally: () => setAreCategoriesReady(true),
        });
        exec();
        return abort;
    }, []);

    return { areCategoriesReady, categories, setCategories };
};

export default useHttpGetCategories;
